// noinspection DuplicatedCode

import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import Button from "@material-tailwind/react/Button";
import Modal from "@material-tailwind/react/Modal";
import ModalBody from "@material-tailwind/react/ModalBody";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import Card from "@material-tailwind/react/Card";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { alertService } from "../../../../services/AlertService";

import Skeltons from "../../../../components/loading/Skeltons";
import { SearchBarSmallV2 } from "../../../../components/form/SearchBar";
import { downloadExcel } from "react-export-table-to-excel";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import { getMinKaryawan } from "../../karyawan/karyawanSlice";
import {
  claimPengobatanTransaksiSelector,
  updateClaimPengobatanTransaksi,
} from "./claimPengobatanTransaksiSlice";
import { approve } from "../../../setup/approval/approvalSlice";

import { Colors } from "../../../../assets/Colors";
import { isRequired, useForm } from "../../../../components/isRequired";
import { KaryawanSelectorBuilder } from "../../karyawan/KaryawanSelector";

import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { fetchPost, fetchPostMultipart } from "../../../../fetchers";

const PAGE_SIZE = 10;
const statusClass = (s) =>
  s === "Selesai"
    ? "text-green-600 font-medium"
    : s === "Ditolak" || s === "Revisi"
    ? "text-red-600 font-medium"
    : s === "Belum Dikirim"
    ? "text-gray-500 font-medium"
    : "text-yellow-600 font-medium";

const ClaimPengobatanPage = ({}) => {
  let initialState = {
    Nik: "",
    JenisPengobatan: "",
    NamaDokter: "",
    RumahSakit: "",
    JenisRawat: -1,
    BiayaDokter: "",
    TotalBiayaObat: "",
  };

  const validations = [
    ({ Nik }) => isRequired(Nik) || { Nik: "NIK wajib diisi" },
  ];

  const {
    changed,
    values,
    isValid,
    errors,
    touched,
    changeHandler,
    editHandler,
    clearHandler,
    customHandler,
    submitHandler,
  } = useForm(initialState, validations);
  const [buttonTouched, setButtonTouched] = useState(false);
  const mutation = useMutation((param) => fetchPost("getPengobatan", param));

  const mutationInput = useMutation((param) =>
    fetchPostMultipart("insertPengobatan", param)
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [TanggalSakit, setTanggalSakit] = useState("");
  const [TanggalSelesai, setTanggalSelesai] = useState("");
  const [isValidTanggalSakit, setIsValidTanggalSakit] = useState(true);
  const [isValidTanggalSelesai, setIsValidTanggalSelesai] = useState(true);
  const [dateChanged, setDateChanged] = useState(false);
  const [firstLoading, setFirstLoading] = useState(false);
  const [start, setStart] = useState(0);
  const [count, setCount] = useState(5);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(0);
  const [search, setSearch] = useState("");
  const [searchFetch, setSearchFetch] = useState(false);
  const [updateFetch, setUpdateFetch] = useState(false);

  const [insertFetch, setInsertFetch] = useState(false);
  const [showModalAdd, setShowModalAdd] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [currentData, setCurrentData] = useState({});
  const [selectedFile, setSelectedFile] = useState(null);
  const [imgData, setImgData] = useState(null);

  const inputArray = [
    {
      type: "text",
      value: "",
    },
  ];
  const [inputArr, setInputArr] = useState(inputArray);

  const claimPengobatan = useSelector(claimPengobatanTransaksiSelector);

  useEffect(() => {
    mutation.mutate({ start: 0, count: 100000, search: "" });
  }, []);

  const reapprove = () => {
    mutation.mutate({ start: 0, count: 100000, search: "" });
  };

  useEffect(() => {
    if (showModalEdit && !showModalAdd) {
      setShowModalAdd(showModalEdit);
      const initValues = {
        Nik: currentData.Nik,
        JenisPengobatan: currentData.JenisPengobatan,
        NamaDokter: currentData.NamaDokter,
        RumahSakit: currentData.RumahSakit,
        JenisRawat: currentData.JenisRawat,
        BiayaDokter: currentData.BiayaDokter,
        TotalBiayaObat: currentData.TotalBiayaObat,
      };
      editHandler(initValues);
      setTanggalSakit(new Date(currentData.TanggalSakit));
      setTanggalSelesai(new Date(currentData.TanggalSelesai));

      if (Object.keys(currentData).length > 0 && inputArr.length === 1) {
        if (currentData.JenisObat.length > 0 && inputArr[0].value === "") {
          let tempData = currentData.JenisObat[0].split(",");
          let tempArr = [];
          for (let i = 0; i < tempData.length; i++) {
            tempArr.push({
              type: "text",
              value: tempData[i],
            });
          }

          setInputArr(tempArr);
        }
      }
    }
  });

  // function handleGetClaimPengobatan(params) {
  //   return dispatch(getClaimPengobatanTransaksi(params));
  // }

  const addInputArr = () => {
    setInputArr((data) => {
      return [
        ...data,
        {
          type: "text",
          value: "",
        },
      ];
    });
  };

  const handleInputArrChange = (e) => {
    e.preventDefault();

    const index = e.target.id;
    setInputArr((data) => {
      const newArr = data.slice();
      newArr[index].value = e.target.value;

      return newArr;
    });
  };

  function handleCurrentData(values) {
    setCurrentData(values);
  }

  function handleModal(status) {
    setShowModalAdd(status.showModalAdd);
    setShowModalEdit(status.showModalEdit);

    dispatch(getMinKaryawan({ search: "" }));
  }

  // ── Data list (client-side search + pagination) ─────────────
  const allRows = useMemo(() => {
    const d = mutation.data?.data;
    return Array.isArray(d) ? d : [];
  }, [mutation.data]);

  const filtered = useMemo(() => {
    const kw = search.trim().toLowerCase();
    if (!kw) return allRows;
    return allRows.filter((r) =>
      [r.TPengobatanID, r.NamaKaryawan, r.JenisRawatKet, r.JenisPengobatan, r.StatusKet].some(
        (v) => v && v.toString().toLowerCase().includes(kw)
      )
    );
  }, [allRows, search]);

  const totalPage = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
  const safePage = Math.min(page, totalPage);
  const pageRows = useMemo(() => {
    const s = (safePage - 1) * PAGE_SIZE;
    return filtered.slice(s, s + PAGE_SIZE);
  }, [filtered, safePage]);

  useEffect(() => {
    setPage(1);
  }, [search, mutation.data]);

  // ── Export (mengikuti hasil filter/search) ───────────────────
  const exportHeader = ["ID", "Nama Karyawan", "Jenis Rawat", "Keterangan", "Tanggal", "Status Approval"];
  const exportBody = () =>
    filtered.map((r) => [
      r.TPengobatanID || "", r.NamaKaryawan || "", r.JenisRawatKet || "", r.JenisPengobatan || "", r.TanggalMonitoring || "", r.StatusKet || "",
    ]);
  const handleDownloadExcel = () => {
    downloadExcel({ fileName: "Claim_Pengobatan", sheet: "data", tablePayload: { header: exportHeader, body: exportBody() } });
  };
  const handleDownloadPDF = () => {
    const doc = new jsPDF({ orientation: "landscape" });
    doc.setFontSize(13);
    doc.text("Claim Pengobatan", 14, 14);
    autoTable(doc, { head: [exportHeader], body: exportBody(), startY: 20, styles: { fontSize: 7 }, headStyles: { fillColor: [30, 58, 95] } });
    doc.save("Claim_Pengobatan.pdf");
  };

  let lamaClaimPengobatan = 0;
  let statusLamaClaimPengobatan = false;
  if (TanggalSakit !== "" && TanggalSelesai !== "") {
    lamaClaimPengobatan = Math.round(
      (TanggalSelesai.getTime() - TanggalSakit.getTime()) /
        (1000 * 60 * 60 * 24)
    );
    if (
      values.SisahClaimPengobatan !== "" &&
      lamaClaimPengobatan > values.SisahClaimPengobatan
    ) {
    }
  }

  return (
    <>
      <div className="md:ml-64">
        <div
          style={{ background: Colors.primary }}
          className="pt-14 pb-16 px-3 md:px-8 h-auto"
        >
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
          </div>
        </div>

        <div className="px-3 md:px-8 h-auto -mt-32">
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 px-4">
              <Card>
                {mutation.isLoading ? (
                  <div className="w-full pt-0"><Skeltons /></div>
                ) : (
                  <>
                    <div className="flex w-full justify-between px-4 pt-4 flex-col sm:flex-row gap-2">
                      <div className="flex flex-row gap-2 flex-wrap">
                        <button
                          onClick={() => handleModal({ showModalAdd: true, showModalEdit: false })}
                          className="flex items-center justify-center my-1 sm:my-0 bg-white text-gray-800 font-semibold py-2 px-4 border border-main-100 hover:bg-main-100 hover:text-white rounded shadow"
                        >
                          Tambah +
                        </button>
                        <button onClick={handleDownloadExcel}
                          className="flex items-center justify-center my-1 sm:my-0 bg-white text-gray-800 font-semibold py-2 px-4 border border-green-600 hover:bg-green-600 hover:text-white rounded shadow">
                          Download Excel
                        </button>
                        <button onClick={handleDownloadPDF}
                          className="flex items-center justify-center my-1 sm:my-0 bg-white text-gray-800 font-semibold py-2 px-4 border border-red-400 hover:bg-red-400 hover:text-white rounded shadow">
                          Download PDF
                        </button>
                      </div>
                      <div className="w-full sm:w-72">
                        <SearchBarSmallV2 text={"Cari Claim Pengobatan"} value={search} funcs={(e) => setSearch(e.target.value)} />
                      </div>
                    </div>

                    <div className="overflow-x-auto px-4 pt-2">
                      <table className="table-auto w-full text-sm text-left text-gray-500 mt-4">
                        <thead className="text-xs text-orange-600 uppercase bg-gray-50">
                          <tr>
                            {["ID", "Nama Karyawan", "Jenis Rawat", "Keterangan", "Tanggal", "Status Approval", "Actions"].map((h, i) => (
                              <th key={i} scope="col" className="py-3 px-6">{h}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {pageRows.length === 0 ? (
                            <tr><td colSpan={7} className="text-center py-8 text-gray-400">
                              {search ? `Tidak ada data untuk "${search}"` : "Tidak ada data"}
                            </td></tr>
                          ) : (
                            pageRows.map((row, id) => (
                              <tr key={row.TPengobatanID || id} className={id % 2 === 0 ? "bg-gray-50 border-b" : "bg-white border-b"}>
                                <td className="py-4 px-6 whitespace-nowrap font-mono text-xs">{row.TPengobatanID}</td>
                                <td className="py-4 px-6">{row.NamaKaryawan || "-"}</td>
                                <td className="py-4 px-6">{row.JenisRawatKet || "-"}</td>
                                <td className="py-4 px-6">{row.JenisPengobatan || "-"}</td>
                                <td className="py-4 px-6 whitespace-nowrap text-xs">{row.TanggalMonitoring || "-"}</td>
                                <td className="py-4 px-6"><span className={statusClass(row.StatusKet)}>{row.StatusKet || "-"}</span></td>
                                <td className="py-4 px-6 whitespace-nowrap">
                                  {["-1", "-2", "-3"].includes(row.Status) && (
                                    <>
                                      <button
                                        onClick={() => { handleModal({ showModalAdd: false, showModalEdit: true }); handleCurrentData(row); }}
                                        className="border text-white bg-main-100 hover:bg-white hover:border-main-100 hover:text-main-100 font-medium rounded-lg text-sm px-4 py-2 mr-2"
                                      >
                                        Edit
                                      </button>
                                      <button
                                        onClick={() => { try { reapprove(); } catch (error) {} dispatch(approve({ primary: row.TPengobatanID })); }}
                                        className="border text-white bg-main-100 hover:bg-white hover:border-main-100 hover:text-main-100 font-medium rounded-lg text-sm px-4 py-2"
                                      >
                                        Kirim
                                      </button>
                                    </>
                                  )}
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>

                    <div className="flex flex-row justify-between items-center gap-4 px-4 py-4 text-sm text-gray-600">
                      <span>{filtered.length} data</span>
                      <div className="flex items-center gap-4">
                        <button onClick={() => setPage((p) => Math.max(1, p - 1))} disabled={safePage <= 1}
                          className="border px-4 py-1 rounded disabled:opacity-50 hover:bg-gray-100">Prev</button>
                        <span>Page {safePage} / {totalPage}</span>
                        <button onClick={() => setPage((p) => Math.min(totalPage, p + 1))} disabled={safePage >= totalPage}
                          className="border px-4 py-1 rounded disabled:opacity-50 hover:bg-gray-100">Next</button>
                      </div>
                    </div>
                  </>
                )}
              </Card>
            </div>
          </div>
        </div>
      </div>
      <Modal
        size="regular"
        active={showModalAdd}
        toggler={() => {
          setShowModalAdd(true);
        }}
      >
        <ModalHeader
          className="mt-20"
          toggler={() => {
            setInputArr([
              {
                type: "text",
                value: "",
              },
            ]);
            setTanggalSakit("");
            setTanggalSelesai("");
            setShowModalAdd(false);
            setShowModalEdit(false);
            setButtonTouched(false);
            clearHandler();
          }}
        >
          {showModalEdit ? "Edit Data" : "Tambah Data"}
        </ModalHeader>
        <ModalBody>
          <form className="w-full max-w-lg" onSubmit={submitHandler}>
            <KaryawanSelectorBuilder
              value={values.Nik}
              onChange={customHandler}
            />
            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-full px-3 md:mb-0">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Rumah Sakit / Klinik *
                </label>
                <input
                  value={values.RumahSakit}
                  onChange={changeHandler}
                  name="RumahSakit"
                  className={
                    (touched.RumahSakit || buttonTouched) && errors.RumahSakit
                      ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                      : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  }
                  type="text"
                />
                {(touched.RumahSakit || buttonTouched) && errors.RumahSakit && (
                  <p className="text-red-500 text-xs italic">
                    {errors.RumahSakit}
                  </p>
                )}
              </div>
            </div>
            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-full px-3 md:mb-0">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Jenis Rawat *
                </label>
                <div className="inline-block relative w-full  ">
                  <select
                    value={values.JenisRawat}
                    onChange={changeHandler}
                    name="JenisRawat"
                    // className=" appearance-none w-full bg-white border hover:border-gray-800 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                    className={
                      (touched.JenisRawat || buttonTouched) && errors.JenisRawat
                        ? "block appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                        : "block appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                    }
                  >
                    <option defaultValue disabled value={-1} hidden>
                      -- Pilih Data --
                    </option>
                    <option value={1}>Rawat Jalan</option>
                    <option value={2}>Rawat Inap</option>
                    <option value={3}>Operasi</option>
                  </select>
                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                    <svg
                      className="fill-current h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                    </svg>
                  </div>
                  {(touched.JenisRawat || buttonTouched) &&
                    errors.JenisRawat && (
                      <p className="text-red-500 text-xs italic">
                        {errors.JenisRawat}
                      </p>
                    )}
                </div>
              </div>
            </div>

            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-full px-3 md:mb-0">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Jenis Pengobatan *
                </label>
                <input
                  value={values.JenisPengobatan}
                  onChange={changeHandler}
                  name="JenisPengobatan"
                  className={
                    (touched.JenisPengobatan || buttonTouched) &&
                    errors.JenisPengobatan
                      ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                      : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  }
                  type="text"
                />
                {(touched.JenisPengobatan || buttonTouched) &&
                  errors.JenisPengobatan && (
                    <p className="text-red-500 text-xs italic">
                      {errors.JenisPengobatan}
                    </p>
                  )}
              </div>
            </div>
            <div className="flex flex-wrap -mx-3 ">
              <div className="w-full md:w-1/2 px-3 mb-6">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Tanggal Mulai *
                </label>
                <DatePicker
                  className={
                    !isValidTanggalSakit
                      ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                      : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  }
                  selected={TanggalSakit}
                  onChange={(date) => {
                    setTanggalSakit(date);
                    setTanggalSelesai("");
                    setIsValidTanggalSakit(true);
                    setIsValidTanggalSelesai(false);
                    if (showModalEdit) {
                      setDateChanged(true);
                    }
                  }}
                />
                {!isValidTanggalSakit && (
                  <p className="text-red-500 text-xs italic">
                    Tanggal mulai wajib diisi
                  </p>
                )}
              </div>

              <div className="w-full md:w-1/2 px-3 mb-6">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Tanggal Akhir *
                </label>
                <DatePicker
                  className={
                    !isValidTanggalSelesai
                      ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                      : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  }
                  disabled={TanggalSakit === ""}
                  minDate={new Date(TanggalSakit).setDate(
                    new Date(TanggalSakit).getDate()
                  )}
                  selected={TanggalSelesai}
                  onChange={(date) => {
                    setTanggalSelesai(date);
                    setIsValidTanggalSelesai(true);
                    if (showModalEdit) {
                      setDateChanged(true);
                    }
                  }}
                />
                {!isValidTanggalSelesai && (
                  <p className="text-red-500 text-xs italic">
                    Tanggal akhir wajib diisi
                  </p>
                )}
              </div>
            </div>
            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-full px-3 mb-6 md:mb-0">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Nama Dokter
                </label>
                <input
                  value={values.NamaDokter}
                  onChange={changeHandler}
                  name="NamaDokter"
                  className={
                    (touched.NamaDokter || buttonTouched) && errors.NamaDokter
                      ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                      : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  }
                  type="text"
                />
                {(touched.NamaDokter || buttonTouched) && errors.NamaDokter && (
                  <p className="text-red-500 text-xs italic">
                    {errors.NamaDokter}
                  </p>
                )}
              </div>
            </div>
            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-full px-3 mb-6 md:mb-0">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Jenis Obat
                </label>
                <div
                  onClick={addInputArr}
                  className={`box-content h-4 w-4 border-2 rounded-full mb-2 items-center justify-center flex ${
                    inputArr[inputArr.length - 1].value.trim().length > 0
                      ? "cursor-pointer border-gray-500"
                      : "pointer-events-none bg-slate-100 border-gray-200"
                  }`}
                >
                  +
                </div>
                {inputArr.map((item, i) => {
                  return (
                    <input
                      className="appearance-none block w-full mb-2 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                      onChange={handleInputArrChange}
                      value={item.value}
                      id={i}
                      type={item.type}
                      size="40"
                    />
                  );
                })}
                {/* <input
                    value={values.JenisObat}
                    onChange={changeHandler}
                    name="JenisObat"
                    className={
                      (touched.JenisObat || buttonTouched) &&
                      errors.JenisObat
                        ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                        : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                    }
                    type="text"
                  />
                  {(touched.JenisObat || buttonTouched) &&
                    errors.JenisObat && (
                      <p className="text-red-500 text-xs italic">
                        {errors.JenisObat}
                      </p>
                    )} */}
              </div>
            </div>
            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Biaya Dokter
                </label>
                <input
                  value={values.BiayaDokter}
                  onChange={changeHandler}
                  name="BiayaDokter"
                  className={
                    (touched.BiayaDokter || buttonTouched) && errors.BiayaDokter
                      ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                      : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  }
                  type="number"
                />
                {(touched.BiayaDokter || buttonTouched) &&
                  errors.BiayaDokter && (
                    <p className="text-red-500 text-xs italic">
                      {errors.BiayaDokter}
                    </p>
                  )}
              </div>
              <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Total Biaya Obat
                </label>
                <input
                  value={values.TotalBiayaObat}
                  onChange={changeHandler}
                  name="TotalBiayaObat"
                  className={
                    (touched.TotalBiayaObat || buttonTouched) &&
                    errors.TotalBiayaObat
                      ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                      : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  }
                  type="number"
                />
                {(touched.TotalBiayaObat || buttonTouched) &&
                  errors.TotalBiayaObat && (
                    <p className="text-red-500 text-xs italic">
                      {errors.TotalBiayaObat}
                    </p>
                  )}
              </div>
            </div>
            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Surat Ketarangan Dokter
                </label>
                <input
                  type="file"
                  onChange={(e) => {
                    setSelectedFile(e.target.files[0]);
                    const reader = new FileReader();
                    reader.addEventListener("load", () => {
                      setImgData(reader.result);
                    });
                    reader.readAsDataURL(e.target.files[0]);
                  }}
                />
              </div>
            </div>
          </form>
        </ModalBody>
        <ModalFooter>
          <Button
            color="red"
            buttonType="link"
            onClick={() => {
              setInputArr([
                {
                  type: "text",
                  value: "",
                },
              ]);
              setTanggalSakit("");
              setTanggalSelesai("");
              setShowModalAdd(false);
              setShowModalEdit(false);
              clearHandler();
            }}
            ripple="dark"
          >
            Cancel
          </Button>

          <Button
            color={
              (isValid || (showModalEdit && dateChanged && !isValid)) &&
              isValidTanggalSakit &&
              isValidTanggalSelesai
                ? "green"
                : "blueGray"
            }
            onClick={() => {
              if (!isValid && changed) {
                setButtonTouched(true);
              }
              let tempIsValid = isValid;
              if (showModalEdit && dateChanged && !isValid) {
                tempIsValid = true;
              }
              if (tempIsValid && isValidTanggalSakit && isValidTanggalSelesai) {
                const tanggal = {
                  TanggalSakit: JSON.stringify(TanggalSakit),
                  TanggalSelesai: JSON.stringify(TanggalSelesai),
                  TPengobatanID: currentData.TPengobatanID,
                };

                let inputArrValues = [];
                for (let i = 0; i < inputArr.length; i++) {
                  inputArrValues.push(inputArr[i].value);
                }
                const inputArray = {
                  JenisObat: inputArrValues,
                };

                const photo = {
                  FileUUID: selectedFile,
                };

                setShowModalAdd(false);
                setShowModalEdit(false);
                if (showModalEdit) {
                  dispatch(
                    updateClaimPengobatanTransaksi(
                      Object.assign(values, tanggal, inputArray, photo)
                    )
                  );
                  reapprove();
                } else {
                  let formData = new FormData();
                  let arr = [];
                  arr.push(values.JenisObat);
                  formData.append("Nik", values.Nik);
                  formData.append("JenisPengobatan", values.JenisPengobatan);
                  formData.append("TanggalSakit", values.TanggalSakit);
                  formData.append("TanggalSelesai", values.TanggalSelesai);
                  formData.append("NamaDokter",values. NamaDokter);
                  formData.append("RumahSakit", values.RumahSakit);
                  formData.append("JenisRawat", values.JenisRawat);
                  formData.append("BiayaDokter", values.BiayaDokter);
                  formData.append("TotalBiayaObat", values.TotalBiayaObat);
                  formData.append("JenisObat", arr);
                  // File resep yang dipilih (selectedFile); dulu values.FileUUID yang tak
                  // pernah diisi → resep tak pernah terkirim saat Tambah.
                  if (selectedFile) formData.append("FileUUID", selectedFile);
          
                  mutationInput.mutate(
                    Object.assign(formData),
                    {
                      onSuccess: async (data, context) => {
                        toast.success(data.message, {
                          position: "bottom-right",
                          autoClose: 5000,
                          hideProgressBar: false,
                          closeOnClick: true,
                          pauseOnHover: false,
                          draggable: true,
                          progress: undefined,
                          theme: "light",
                        });
                        setShowModalAdd(false);
                        setShowModalEdit(false);
                        reapprove();
                      },
                      onError: async (data, context) => {
                        toast.error(data.message, {
                          position: "bottom-right",
                          autoClose: 5000,
                          hideProgressBar: false,
                          closeOnClick: true,
                          pauseOnHover: false,
                          draggable: true,
                          progress: undefined,
                          theme: "light",
                        });
                      },
                    }
                  );
                }
              }
            }}
            ripple={isValid ? "light" : ""}
          >
            SUBMIT
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default ClaimPengobatanPage;
